module.exports = __webpack_public_path__ + "static/signUpBg-bf0620d95435dfa1f4b0ae32dadd679d.png";